import { z } from 'zod'

import { TaskCategory, TaskType } from './tasks'

export type EntityType = 'booking' | 'shipment'

export const RequiredActionV2Schema = z.object({
  id: z.string(),
  entityId: z.string(),
  entityType: z.enum(['booking', 'shipment']),
  active: z.boolean(),
  category: z
    .nativeEnum(TaskCategory)
    .nullish()
    .transform((data) => data ?? undefined),
  completed: z.boolean(),
  completedBy: z
    .object({
      id: z.string(),
      name: z.string(),
    })
    .nullish()
    .transform((data) => data ?? undefined),
  description: z.string(),
  i18n: z.object({
    term: z
      .string()
      .nullish()
      .transform((data) => data ?? undefined),
    params: z
      .string()
      .nullish()
      .transform((data) => data ?? undefined),
  }),
  type: z
    .nativeEnum(TaskType)
    .nullish()
    .transform((data) => data ?? undefined),
  customerDueDate: z.coerce
    .date()
    .nullish()
    .transform((data) => data ?? undefined),
  critical: z
    .boolean()
    .nullish()
    .transform((data) => data ?? false),
})

export type RequiredActionV2 = z.infer<typeof RequiredActionV2Schema>
